import React from 'react';

export interface RadioProps {
  name: string;
  value: string;
  checked: boolean;
}

const Radio = ({ name, value, checked }: RadioProps) => (
  <input
    type="radio"
    name={name}
    value={value}
    className="tw-w-6 tw-h-6 tw-relative before:tw-block before:tw-absolute before:tw-h-full before:tw-bg-white checked:before:tw-bg-action-500 before:tw-inset-0 before:tw-rounded-full before:tw-border-2 before:tw-border-text-300 before:tw-transition-colors after:tw-absolute after:tw-inset-[7px] after:tw-block after:tw-rounded-full checked:after:tw-bg-white after:tw-transition-colors after:tw-duration-200 after:tw-delay-150"
    checked={checked}
  />
);

export default Radio;
